export class Coordinates{
    public latitude?: number = 0;
    public longitude?: number = 0;
    constructor(lat: number, long: number) {
        this.latitude = lat;
        this.longitude = long;
    }
}